"use strict";
module.exports = {
    entityModel: 'mappingTemplate',
    events: {
        MAPPING_TEMPLATE_CREATED: 'MAPPING_TEMPLATE_CREATED',
        MAPPING_TEMPLATE_UPDATED: 'MAPPING_TEMPLATE_UPDATED',
        MAPPING_TEMPLATE_ACTIVATED: 'MAPPING_TEMPLATE_ACTIVATED',
        MAPPING_TEMPLATE_DEACTIVATED: 'MAPPING_TEMPLATE_DEACTIVATED',
    },
    actions: {
        get: 'v1.mappingTemplate.get',
        list: 'v1.mappingTemplate.list',
        writeMappingTemplate: 'v1.mappingTemplate.writeMappingTemplate',
        deactivate: 'v1.mappingTemplate.deactivate',
        activate: 'v1.mappingTemplate.activate',
        upsert: 'v1.mappingTemplate.upsert',
        upsertWhenEmpty: 'v1.mappingTemplate.upsertWhenEmpty',
        updateWhenEmpty: 'v1.mappingTemplate.updateWhenEmpty',
        update: 'v1.mappingTemplate.update',
    },
    entities: {
        article: 'article',
        supplierCustomer: 'supplierCustomer',
        invite: 'invite',
        brand: 'brand',
        priceList: 'priceList',
        order: 'order',
    },
    belongingActions: {
        'v1.article.importArticle': 'v1.article.importArticle',
        'v1.supplierCustomer.importCustomer': 'v1.supplierCustomer.importCustomer',
        'v1.invite.sendSupplierCustomerInvite': 'v1.invite.sendSupplierCustomerInvite',
        'v1.brand.writeBrand': 'v1.brand.writeBrand',
        'v1.priceList.writePriceListFast': 'v1.priceList.writePriceListFast',
        'v1.order.writeOrder': 'v1.order.writeOrder',
    },
    mappingFields: {},
};
